import React from 'react';
import { PropTypes } from 'prop-types';
import { Icons, Button, Heading, Text, Spacer, Box, Stack } from 'sarsaparilla';
import { get, isNil } from 'lodash';

import { GROUP_DETAIL_ALT_PROP_PATH, GROUP_INFO_PROP_PATH, GROUP_LEADERS_GUIDES_PROP_PATH } from '../constants/propPaths';
import CommercialGuideItem from './CommercialGuideItem';

const blankGuide = {
  first_name: '',
  last_name: '',
  license_number: '',
  license_expiration_date: '',
  employee_id: '',
};

const defaultDataBindingMap = {
  [GROUP_DETAIL_ALT_PROP_PATH]: 'alt_group_leaders',
  [GROUP_INFO_PROP_PATH]: 'group_info',
  [GROUP_LEADERS_GUIDES_PROP_PATH]: 'guides'
};

const defaultProps = {
  guidesSubtext: 'Please list all guides that will be going on this trip.'
};

const defaultAttributes = {};
export default (issuanceShape, newDataBindingsMap = defaultDataBindingMap, attributes = defaultAttributes) => {
  const dataBindingsMap = {...defaultDataBindingMap, ...newDataBindingsMap};

  class CommercialGuideList extends React.Component {
    addGuide = () => {
      const { reservation, pActions } = this.props;

      const altCount = get(reservation, `${dataBindingsMap[GROUP_DETAIL_ALT_PROP_PATH]}.length`, 0);
      let guides = get(reservation, dataBindingsMap[GROUP_LEADERS_GUIDES_PROP_PATH]);
      if (isNil(guides)) {
        guides = [];
      }
      const guidesCount = guides.length;
      const groupCount = get(reservation, dataBindingsMap[GROUP_INFO_PROP_PATH], []).length;
      // primary permit holder + alternate permit holders + commercial leaders
      if (altCount + guidesCount < groupCount && altCount + guidesCount < 10) {
        guides = [...guides, blankGuide];
        pActions.updatePendingReservation(reservation.id, dataBindingsMap[GROUP_LEADERS_GUIDES_PROP_PATH], guides);
      }
    }

    handleGuideChange = (index, guide) => {
      const { reservation, pActions } = this.props;
      const newGuide = {
        ...guide
      };
      pActions.updatePendingReservation(reservation.id, `${dataBindingsMap[GROUP_LEADERS_GUIDES_PROP_PATH]}[${index}]`, newGuide);
    }

    handleGuideRemove = (index) => {
      const { reservation, pActions } = this.props;
      const guides = [...get(reservation, dataBindingsMap[GROUP_LEADERS_GUIDES_PROP_PATH], [])];
      guides.splice(index, 1);
      pActions.updatePendingReservation(reservation.id, dataBindingsMap[GROUP_LEADERS_GUIDES_PROP_PATH], guides);
    }

    renderList = () => {
      const { reservation } = this.props;
      let guides = get(reservation, dataBindingsMap[GROUP_LEADERS_GUIDES_PROP_PATH]);
      if (isNil(guides)) {
        guides = [];
      }

      return guides.map((guide, index) => {
        const newGuide = {
          ...guide
        };
        const key = `guid__${index}`;
        return (
          <CommercialGuideItem
            key={key}
            index={index}
            guide={newGuide}
            allGuides={this.props.allGuides}
            handleGuideChange={this.handleGuideChange}
            handleGuideRemove={() => this.handleGuideRemove(index)} />
        )
      });
    }

    render() {
      const { reservation, account, guidesSubtext  } = this.props;
      if (!account.is_commercial_account && reservation.type !== 1) {
        return null;
      }
      let guides = get(reservation, dataBindingsMap[GROUP_LEADERS_GUIDES_PROP_PATH]);
      if (isNil(guides)) {
        guides = [];
      }

      return (
        <Stack>
          <Heading headingLevel={2} appearance="h5">
            Employees and Guides
          </Heading>
          <Text>{guidesSubtext}</Text>
          {this.renderList()}
          <Box>
            <Button
              appearance="link"
              onClick={this.addGuide}
              iconBeforeElement={<Icons.IconAddCircle />}>
              Add another employee or guide
            </Button>
          </Box>
          <Spacer size="lg" />
        </Stack>
      );
    }
  }

  CommercialGuideList.propTypes = {
    validation: PropTypes.shape({}).isRequired,
    account: PropTypes.shape({
      is_commercial_account: PropTypes.bool.isRequired
    }).isRequired,
    allGuides: PropTypes.arrayOf(PropTypes.shape({})),
    reservation: issuanceShape,
    pActions: PropTypes.shape({
      formValidationChange: PropTypes.func.isRequired,
      updatePendingReservation: PropTypes.func.isRequired
    }).isRequired,
    guidesSubtext: PropTypes.string,
  };

  CommercialGuideList.defaultProps = defaultProps;
  CommercialGuideList.attributes = attributes;
  CommercialGuideList.componentName = "CommercialGuideList";

  return CommercialGuideList;
}
